import React from "react";
import imgAddSite from "../../../assets/siteManagement/images/add-site.svg";
// import AddSiteIcon from "../../ui/AddSiteIcon";
import AddSiteIcon from "../../site_management/icons/AddSiteIcon.jsx";
import { useTranslation } from "react-i18next";

function SiteCardAdd(props) {
  const { t } = useTranslation("settings");

  function onClickCard(param) {
    if (props.disable) return;

    try {
      props.onClick();
    } catch {}
  }
  return (
    <div
      // className="w-24 h-24 shadow-xl rounded-lg mr-2 flex justify-center items-center cursor-pointer hover:scale-105 transition-all duration-300"
      // style={{
      //   background:
      //     // "linear-gradient(167.96deg, #091A27 4.17%, #234157 28.65%, #387484 64.58%, #34A182 100%)",
      //     "linear-gradient(167.96deg,#2A0B0D 4.17%, #7A1014 28.65%, #B2151B 50%, #ED1C24 75%, #DC3545 100%)"

      // }}
      className="w-24 h-24 shadow-xl rounded-lg mr-2 flex justify-center items-center cursor-pointer hover:scale-105 transition-all duration-300 bg-gradient-to-br from-vekin-primary to-vekin-primary-dark"
      onClick={(e) => {
        onClickCard(e);
      }}
    >
      <div>
        <div className="w-full flex justify-center mb-2">
          {/* <img className="w-8 h-8" src={imgAddSite} alt="" /> */}
          <AddSiteIcon className="w-8 h-8 text-vekin-primary-light" />
        </div>
        <p className="text-white text-xs text-semibold">
          {t("site_management.new_site")}
        </p>
      </div>
    </div>
  );
}

export default SiteCardAdd;
